import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../Header/PageHeader";
import { useNavigate } from "react-router-dom";
import DEFAULT_ROUTES from "../../constants/routes";
import { setActivePage } from "../../features/navigation/navigationSlice";
import { Box } from "@mui/material";
import TabView from "../tabView/TabView";
import VariablesComponent from "./VariablesComponent";
import EnvironmentComponent from "./EnvironmentComponent";
import styles from "../../styles/component.module.scss";

const PAGE_TITLE = "Variables & Environment";
const PAGE_DESCRIPTION = "View, create, and manage your variables and environment.";
const DEFAULT_PROJECT_NAME = "Project_Name";

export default function VariablesAndEnvironment() {
    const { selectedProject } = useSelector((state) => state.projects);
    const { activePage } = useSelector((state) => state.navigation);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBreadcrumbClick = (id) => {
        const breadcrumbMap = {
            home: {
                rURL: DEFAULT_ROUTES.BASE_URL,
                activePage: "Projects",
            },
            project: {
                rURL: `${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${selectedProject.id}/test-cases`,
                activePage: "Test Cases",
            },
        };

        const { rURL, activePage: nextActivePage } = breadcrumbMap[id] || {};

        if (nextActivePage) {
            dispatch(setActivePage(nextActivePage));
        }
        if (rURL) {
            navigate(rURL);
        }
    };

    const breadcrumbList = useMemo(() => {
        return [
            {
                label: "Project",
                onClick: () => handleBreadcrumbClick("home"),
              },
              {
                label: selectedProject?.name || DEFAULT_PROJECT_NAME,
                onClick: () => handleBreadcrumbClick("project"),
              },
              { label: activePage },
        ]
    }, [selectedProject, activePage]);
    

    const tabsData = [
        {
            name: 'Variables',
            component: <VariablesComponent />
        },
        {
            name: 'Environment',
            component: <EnvironmentComponent />
        }
    ];

    return (
        <Box className={styles['page-container']}>
          <Box>
            <PageHeader 
                projectName={selectedProject?.name}
                title={PAGE_TITLE}
                description={PAGE_DESCRIPTION}
                activePage={activePage}
                breadcrumbItems={breadcrumbList}
                actions={[]}
            />
          </Box>
            <Box sx={{ width: '100%', paddingX: 2, paddingTop: 0 }} className={styles['cover-container-col']}>
                <TabView 
                    tabsData={tabsData} 
                />
            </Box>
        </Box>
    )
}